<div class="item-content">
  @if (deleteError) {
    <div class="error-message">{{ deleteError }}</div>
  }
  <div class="stats-overview">
    <button
      class="add-source-btn"
      (click)="showAddSourceQuota()"
      [disabled]="!hasAvailableSourceTypes()"
    >
      <app-svg-icon
        [iconName]="'add.svg'"
        [height]="'14px'"
        [width]="'14px'"
        [style.fill]="'#334ea5'"
      ></app-svg-icon>
      Add Source
    </button>
    <div class="sources-table">
      <table>
        <thead>
          <tr>
            <th>Source</th>
            <th>Max Quota</th>
            <th>Available</th>
            <th>Used</th>
            <th>Usage</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (detail of cdfiLeadsQuota.details; track $index) {
            <tr>
              <td class="source-cell">
                <span class="source-badge">{{
                  detail.source_display_name
                }}</span>
              </td>
              <td>
                @if (
                  editingQuota?.connectionId === cdfiLeadsQuota.connection_id &&
                  editingQuota?.sourceType === detail.source_type
                ) {
                  <div class="inline-edit">
                    <input
                      type="number"
                      [(ngModel)]="tempMaxQuota"
                      min="0"
                      [class.error]="quotaError !== null"
                    />
                    @if (quotaError) {
                      <div class="error-message">
                        {{ quotaError }}
                      </div>
                    }
                    <div class="edit-actions">
                      <button
                        class="save-btn"
                        (click)="UpdateSourceQuota(detail.source_type)"
                      >
                        <svg viewBox="0 0 24 24">
                          <path
                            d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                          />
                        </svg>
                      </button>
                      <button class="cancel-btn" (click)="cancelEdit()">
                        <svg viewBox="0 0 24 24">
                          <path
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                } @else {
                  <div class="value-with-edit">
                    <span style="width: 35px">{{ detail.max_quota }}</span>
                    <button
                      class="edit-icon"
                      title="Edit"
                      (click)="
                        startEdit(
                          cdfiLeadsQuota.connection_id,
                          detail.source_type,
                          detail.max_quota
                        )
                      "
                    >
                      <svg viewBox="0 0 24 24">
                        <path
                          d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z"
                        />
                      </svg>
                    </button>
                  </div>
                }
              </td>
              <td>{{ detail.available_quota }}</td>
              <td>{{ detail.used_quota }}</td>
              <td>
                <div class="usage-bar">
                  <div
                    class="progress"
                    [style.width.%]="
                      (detail.used_quota / detail.max_quota) * 100
                    "
                    [class.warning]="
                      detail.used_quota / detail.max_quota > 0.7 &&
                      detail.used_quota / detail.max_quota <= 0.9
                    "
                    [class.alert]="detail.used_quota / detail.max_quota > 0.9"
                  ></div>
                  <span class="usage-text"
                    >{{
                      (detail.used_quota / detail.max_quota) * 100
                        | number: "1.0-0"
                    }}%</span
                  >
                </div>
              </td>
              <td class="actions">
                <button
                  class="delete-icon"
                  title="Delete"
                  (click)="deleteConfirmPopupHandler(detail)"
                >
                  <app-svg-icon
                    [iconName]="'delete.svg'"
                    [height]="'14px'"
                    [width]="'14px'"
                    [style.fill]="'#64748b'"
                  ></app-svg-icon>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>

@if (showAddSourceQuotaPopup) {
  <app-popup
    [heading]="'Add Quota for source'"
    [confirmText]="'Add'"
    [cancelText]="'Cancel'"
    (confirmClicked)="createSourceQuota()"
    (cancelClicked)="showAddSourceQuotaPopup = false"
  >
    <div class="add-quota-form">
      @if (addQuotaError) {
        <div class="error-message">{{ addQuotaError }}</div>
      }

      <div class="form-group">
        <label for="sourceType">Source Type</label>
        <select
          id="sourceType"
          [(ngModel)]="newQuota.sourceType"
          class="quota-input"
        >
          <option [ngValue]="null">Select a source type</option>
          @for (type of sourceTypesDropDown; track $index) {
            <option [ngValue]="type.source_type">
              {{ type.source_display_name }}
            </option>
          }
        </select>
      </div>

      <div class="form-group">
        <label for="maxQuota">Max Quota</label>
        <input
          id="maxQuota"
          type="number"
          [(ngModel)]="newQuota.maxQuota"
          min="0"
          class="quota-input"
        />
      </div>
    </div>
  </app-popup>
}

@if (showDeleteConfirmPopup) {
  <app-popup
    [heading]="'Confirm Delete'"
    [confirmText]="'Delete'"
    [cancelText]="'Cancel'"
    (confirmClicked)="deleteSourceTypeQuota(selectedSourceQuota!.source_type)"
    (cancelClicked)="showDeleteConfirmPopup = false"
  >
    Are you sure you want to delete
    {{ selectedSourceQuota?.source_display_name }} source type quota?
  </app-popup>
}
